import { Scrollbars } from 'react-custom-scrollbars';

var Modal = require("components/utility/AltModal");
var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var StudentOnboardingImage = require("components/users/students/onboarding/StudentOnboardingImage");
var OwlfonsoChat = require("components/users/students/onboarding/OwlfonsoChat");

require("users/students/student_onboarding_modal.scss");

class StudentOnboardingModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var isAssignments = true;
		var isSplitOnboarding = true;

		if (isSplitOnboarding) {
			if (props.writingTriggered) {
				var conversationData = require("student-onboarding-later-partial.csv");
			} else if (isAssignments) {
				var conversationData = require("student-onboarding-partial-assignments.csv");
			} else {
				var conversationData = require("student-onboarding-partial-control.csv");
			}
		} else {
			if (isAssignments) {
				var conversationData = require("student-onboarding-control-assignments.csv");
			} else {
				var conversationData = require("student-onboarding-control-control.csv");
			}
		}

		this.state = { conversationData: conversationData, stage: 0, chatHistory: [], preventHide: true };
	}
	
	skipOnboarding() {
		LuckyOrangeClient.tagComponent("skipStudentOnboarding");
		this.endOnboarding();
	}

	endOnboarding(e) {
		$wr.nope(e)

		if (!this.props.writingTriggered) {
			// mark onboarding complete
			var studentID = CurrentUser.get().id;
			var studentData = { pending_onboarding: false };
			CurrentUser.api().patchStudent(studentID, { student: studentData }, $wr.apiHandler((response) => {
				this.setState({ preventHide: false }, () => {
					CurrentUser.fetchCurrentUserData();
					this.refs.modal.hide();
				});
			}));
		} else {
			$wr.redirect(this.props.redirectPath);
			this.refs.modal.hide();
		}
	}

	logOut(e) {
		$wr.nope(e)
		CurrentUser.logOut();
		window.location = WhooosReadingServices.OuterPages.url("/");
	}

	advanceStage(lastChat, increment) {
		// end onboarding if we are at the final stage
		if (this.state.stage == (_.size(this.state.conversationData) - 1)) {
			this.endOnboarding();
			return;
		}

		var newHistory = this.state.chatHistory;
		newHistory.push(lastChat);

		var incrementAmount = parseInt(increment) || 1;
		var newStage = this.state.stage + incrementAmount;

		this.setState({ stage: newStage, chatHistory: newHistory });
	}

	render() {
		var user = CurrentUser.get();
		var currentChat = _.findWhere(this.state.conversationData, { stage: this.state.stage });

		if (user.demo_for_teacher) {
			var logOutLink = (
				<div className="logOutLink">
				<a href="#" onClick={ this.logOut }>Log Out</a>
				<span className="separator">|</span>
				<a href="#" onClick={ this.skipOnboarding } >Skip</a>
				</div>
			);
		} else {
			var logOutLink = (
				<a href="#" className="logOutLink" onClick={ this.logOut }>Log Out</a>
			);
		}
		var studentOptions = (currentChat.speaker == "student") && (currentChat.type == "options");
		var leftContent = (
			<StudentOnboardingImage stage={ this.state.stage }
				hasStudentOptions={ studentOptions }
				level={ CurrentUser.getLevel() }
				imgPath={ currentChat.imgPath } />
		)
		var hiddenSkipLink = (
			<a className="hiddenSkipLink" onClick={ this.skipOnboarding }></a>
		)

		var leftColDisplay = (
			<div className="leftColWrapper">
				<div className="leftCol">
					{ logOutLink }
					{ hiddenSkipLink }
					{ leftContent }
				</div>
			</div>
		);

		var initialOnly = (currentChat && currentChat.initialOnly);
		var rightContent = (
			<OwlfonsoChat history={ this.state.chatHistory } currentChat={ currentChat }
				advanceStageF={ this.advanceStage } initialOnly={ initialOnly }
				scrollToBottomF={ () => { this.refs.scrollbar.scrollToBottom() } } />
		);

		var rightColDisplay = (
			<div className="rightColWrapper">
				<Scrollbars className="modalScroll" ref="scrollbar"
					style={{ height: 450 }}>

					<div className="rightCol">
						{ rightContent }
					</div>
				</Scrollbars>
			</div>
		);


		return (
			<Modal className="studentOnboardingModal" preventHide={ this.state.preventHide } ref="modal">
				<div className="modalContent">
			 		{ leftColDisplay }
			 		{ rightColDisplay }
			 	</div>
			</Modal>
		);
	}

	componentDidMount() {
		this.refs.modal.show();
		Mycroft.newEvent({ category: "Student Onboarding", action: "started-chat" });
	}
}

StudentOnboardingModal.propTypes = StrictPropTypes({
	// true when triggered upon answering a question or doing a quiz
	writingTriggered: PropTypes.bool,

	// redirect path
	redirectPath: PropTypes.string,
});

module.exports = StudentOnboardingModal;


// WEBPACK FOOTER //
// ./modules/components/users/students/onboarding/StudentOnboardingModal.js